import { ApiClient } from "@/services/apiClient";
import type { AutocompleteCollectibleItem, Collectible, CollectibleId } from "@/services/collectibles/collectiblesTypes";
import type { CategoryId } from "@/services/collection/categories";

/** @deprecated Still used in magazine widgets. Use Elastic Collectible instead. */
export const fetchCollectibleById = async (id: CollectibleId): Promise<Collectible> => {
  const url = "api-public/collectible/" + id;
  return ApiClient.getPublic<Collectible>(url).then(({ data }) => data);
};

export const searchCollectibleForAutocomplete = async (categoryId: CategoryId, q: string): Promise<AutocompleteCollectibleItem[]> => {
  const url = "api-public/collectible/autocomplete/" + categoryId;
  const params = { q };
  return ApiClient.getPublic<AutocompleteCollectibleItem[]>(url, params).then(({ data }) => data);
};
